import { MapBrowserEvent } from 'ol'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { selectParcel } from '../../common/slice'
import { useAppDispatch } from '../../common/store'
import { replaceSpaceWithX, useQuery } from '../../common/util'
import {
  LAYER_MAPMARKER_NEIGHBOUR_COLOUR,
  LAYER_MAPMARKER_PRIMARY_COLOUR,
  PLANNING_MAP_CLICK_ENABLED,
  PLANNING_SERVICES_EMAIL,
  PLANNING_SERVICES_PHONE,
  PLANNING_SERVICES_PHONE_INTERNATIONAL,
  PLANNING_SUB_PATH,
} from '../../environment'
import { MapConfigComponentProps } from '../map/MapComponent'
import { DEFAULT_LAYERS, lotBoundaryWmsSource } from '../map/map.constants'
import MapMarkers, { MapMarker } from '../map/MapMarkers'
import VctFooter from '../vct-footer/VctFooter'
import PlanningMarkerPopup from './PlanningMarkerPopup'
import { PlanningData } from './slice'
import { usePlanningData } from './util'


const PlanningMapConfig = ({ map, zoomTo, setReturnLocation, onSingleClick }: MapConfigComponentProps) => {
  const primaryMarker = usePlanningData()?.parcelPlanningItem
  let otherMarkers = usePlanningData()?.parcelNeighbourItems
  const dispatch = useAppDispatch()
  const query = useQuery()
  const history = useHistory()

  if (map) {
    map.setLayers(DEFAULT_LAYERS)
  }

  useEffect(
    () => {
      if (primaryMarker) {
        if (query.get('zoomto') !== 'false') zoomTo(primaryMarker)
        setReturnLocation(primaryMarker)
        dispatch(selectParcel(replaceSpaceWithX(primaryMarker.laisKey)))
      }
    },
    [primaryMarker],
  )

  useEffect(() => {
    if (map) {
      map.on('singleclick', handleSingleClick)
      return () => {
        map.un('singleclick', handleSingleClick)
      }
    }
  }, [map])

  const handleSingleClick = async (evt: MapBrowserEvent<UIEvent>) => {
    if (PLANNING_MAP_CLICK_ENABLED) {
      const placeObj: any = await onSingleClick(evt, lotBoundaryWmsSource)
      if (placeObj) {
        let laiskey: string = replaceSpaceWithX(placeObj.properties.LAISKEY)
        let path = `${PLANNING_SUB_PATH}/${laiskey}`
        history.push(path)
      }
    }

  }

  return (
    <React.Fragment>
      {primaryMarker &&
          <MapMarkers map={map}>
              <MapMarker<PlanningData>
                  latitude={primaryMarker.latitude}
                  longitude={primaryMarker.longitude}
                  data={primaryMarker}
                  iconColor={LAYER_MAPMARKER_PRIMARY_COLOUR}
                  iconSize={'big'}/>
          </MapMarkers>
      }

      {otherMarkers && <MapMarkers map={map}>
        {otherMarkers.map((d) => {
          return (
            <MapMarker<PlanningData>
              key={d.parcelId}
              latitude={d.latitude}
              longitude={d.longitude}
              data={d}
              iconColor={LAYER_MAPMARKER_NEIGHBOUR_COLOUR}
              iconSize={'large'}
              popupComponent={PlanningMarkerPopup}
            />
          )
        })}
      </MapMarkers>}
      <VctFooter contactEmail={PLANNING_SERVICES_EMAIL} contactPhone={PLANNING_SERVICES_PHONE}
                 contactPhoneInternational={PLANNING_SERVICES_PHONE_INTERNATIONAL}/>
    </React.Fragment>

  )
}

export default PlanningMapConfig